import { useContext } from "react";
import { UPCUploaderContext } from "../provider/upc-uploader-context";

export const useUPCUploader = () => useContext(UPCUploaderContext);
